import Image from 'next/image';
import { FC } from 'react';

import { Skeleton } from '@mui/material';
import { useInView } from 'react-intersection-observer';

import InteractiveCoverImageStyle from './style';

import { ICoverPhoto } from '@interfaces/app';

type Props = {
  item: ICoverPhoto;
  coverPhotoTouchStart: (e?: React.TouchEvent | React.MouseEvent) => void;
  coverPhotoTouchMove?: (e?: React.TouchEvent | React.MouseEvent) => void;
  coverPhotoTouchEnd: (item: ICoverPhoto) => void;
};

const InteractiveCoverImage: FC<Props> = ({ item, coverPhotoTouchStart, coverPhotoTouchMove, coverPhotoTouchEnd }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <InteractiveCoverImageStyle
      ref={ref}
      onTouchStart={coverPhotoTouchStart}
      onTouchMove={coverPhotoTouchMove}
      onTouchEnd={() => coverPhotoTouchEnd(item)}
      onMouseDown={coverPhotoTouchStart}
      onMouseMove={coverPhotoTouchMove}
      onMouseUp={() => coverPhotoTouchEnd(item)}
    >
      {inView ? (
        <Image
          alt={item.alt || 'คอร์สใหม่ล่าสุด'}
          src={item.img}
          layout="responsive"
          width={960}
          height={304}
          priority
        />
      ) : (
        <Skeleton
          variant="rectangular"
          animation="wave"
          sx={{ aspectRatio: '3.1 / 1', height: '100%', borderRadius: '10px' }}
        />
      )}
    </InteractiveCoverImageStyle>
  );
};

export default InteractiveCoverImage;
